var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .statusers_s0 { fill: #fdb22b } \n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-stat-users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-workspace-stat-users-path",
    className: "statusers_s0",
    d: "m12.5 12.5c-0.7 1-1.9 1.6-3.2 1.6-1.3 0-2.5-0.6-3.2-1.6-2.8 0.6-5.8 2-5.8 4.1v2.5h18v-2.5c0-2.1-3-3.5-5.8-4.1zm-3.2-11.4c-2.2 0-4 1.8-4 4 0 2.2 1.8 4 4 4 2.2 0 4-1.8 4-4 0-2.2-1.8-4-4-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.6df35c41cb18a30b604a357a7c897d8c.svg";
export { ForwardRef as ReactComponent };